import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import useGlobalStore from 'hooks/useGlobalStore';
import usePageRoutes from 'hooks/usePageRoutes';

const CurrentUserGuard = ({ onPassed }: { onPassed?: (passed: boolean) => void }) => {
    const navigate = useNavigate();
    const { onboardingCurrentUserPage } = usePageRoutes();

    const { getValue } = useGlobalStore({
        namespace: 'useCurrentUser'
    });
    const currentUser = getValue('currentUser');

    const [hasAllFields, setHasAllFields] = useState<boolean | null>(null);

    const checkUserFields = async () => {
        const { firstName, lastName, phone } = currentUser ?? {};
        const fieldsComplete = Boolean(firstName && lastName && phone);

        setHasAllFields(fieldsComplete);

        if (!fieldsComplete) {
            navigate(onboardingCurrentUserPage);
        }
    };

    useEffect(() => {
        checkUserFields();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (hasAllFields === null) {
        return null;
    }

    if (hasAllFields) {
        onPassed?.(true);

        return <Outlet />;
    }

    return null;
};

export default CurrentUserGuard;
